/**
 * <price-buckets> — fixed price-range filter (PLP).
 *
 * Renders as a radiogroup of range buttons. Selecting one writes the chosen
 * bounds into the two hidden `filter.v.price.gte` / `.lte` inputs that live inside
 * Dawn's facet form, then dispatches a bubbling `input` event so facets.js's
 * debounced submit picks it up and runs its normal (AJAX) filter render. Clicking
 * the already-selected range clears the price filter.
 *
 * Buttons (not native radios) so there are no name/grouping quirks and nothing
 * extra leaks into the submitted form data — only the two hidden inputs do.
 */
class PriceBuckets extends HTMLElement {
  connectedCallback() {
    this.greaterThanOrEqualInput = this.querySelector('[data-price-gte]');
    this.lessThanOrEqualInput = this.querySelector('[data-price-lte]');

    this.addEventListener('click', (event) => {
      const bucketButton = event.target.closest('.price-bucket');
      if (!bucketButton) return;

      const wasSelected = bucketButton.getAttribute('aria-checked') === 'true';
      this.querySelectorAll('.price-bucket').forEach((button) => button.setAttribute('aria-checked', 'false'));

      if (wasSelected) {
        this.setBounds('', ''); // toggle off → clear the price filter
      } else {
        bucketButton.setAttribute('aria-checked', 'true');
        this.setBounds(bucketButton.dataset.gte, bucketButton.dataset.lte);
      }

      this.submitFacetForm();
    });
  }

  setBounds(greaterThanOrEqual, lessThanOrEqual) {
    if (this.greaterThanOrEqualInput) this.greaterThanOrEqualInput.value = greaterThanOrEqual;
    if (this.lessThanOrEqualInput) this.lessThanOrEqualInput.value = lessThanOrEqual;
  }

  submitFacetForm() {
    // facets.js listens for `input` on the facet form (its debounced submit); the
    // grid loader listens for `change`. Both bubble up from here. facets.js has no
    // `change` listener, so this does not double-submit.
    this.dispatchEvent(new Event('input', { bubbles: true }));
    this.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('price-buckets')) {
  customElements.define('price-buckets', PriceBuckets);
}
